import {Button, ComposedModal, ModalBody, ModalFooter} from "@carbon/react";
import {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {addModal, closeModal, toggleModal} from "../../../features/application/applicationSlice.js";
import {convertToHTML} from "../utils.js";
import ModalStateManager from "../../Modal/index.js";

const Index = ({chart, modalId}) => {
    const dispatch = useDispatch();
    const modal = useSelector((state) => state.application.modals)
    const [modalState, setModalState] = useState(false)
    const title = chart.title
    const user_description = chart.user_description

    const col_desc = (chart.col_desc || []).map((a, index) => {
        return <div className={'column-info'} key={`${a.column_name}#${index}`}>
            <h5
                className={'column-name'}>{a.column_title ? a.column_title.toUpperCase() : a.column_name.toUpperCase()}</h5>
            <span className={'column-description'}>{convertToHTML(a.description)}</span>
        </div>
    })
    let user_desc = <></>
    if (user_description && user_description !== '') {
        user_desc = <>
            <div className={'user-description-container'}>
                <h5>Notas del usuario</h5>
                {user_description}
            </div>
        </>
    }
    const extras = <div className={'info-container'}>
        <h2>{title}</h2>
        <div className={'tooltip-container'}>
            {chart.tooltip}
        </div>
        {user_desc}
        <div className={'column-info-container'}>
            {col_desc}
        </div>
    </div>

    const modalService = ModalStateManager(
        {
            children:
                <>
                    <ComposedModal className={''} open={modalState}
                                   onClose={() => dispatch(closeModal(modalId))} size="md">
                        <ModalBody>
                            {extras}
                        </ModalBody>
                        <ModalFooter>
                            <Button
                                kind="primary" onClick={() => {
                                dispatch(toggleModal(modalId))
                            }}>
                                Cerrar
                            </Button>
                        </ModalFooter>
                    </ComposedModal>
                </>
        }
    )

    // Añadir modal solo una vez al montar
    useEffect(() => {
        dispatch(addModal(modalId))
    }, [dispatch, modalId])
    
    // Actualizar estado del modal cuando cambia
    useEffect(() => {
        let mState = modal.find((m) => m.id === modalId)
        mState = mState ? mState.state : false
        setModalState(() => mState)
    }, [modal, modalId])

    return (
        <div>
            {modalService}
        </div>
    )

}


export default Index
